import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ChannelType, ChannelUser } from '@pixacare/chat';
import { UserNamePipe } from '@shared/pipes/user-name.pipe';
import { TuiIcon } from '@taiga-ui/core';
import { Size } from 'src/app/shared/models/enums/size.enum';
import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { ChatHideMyselfPipe } from '../pipes/chat-hide-myself.pipe';

@Component({
  selector: 'pxc-channel-avatar',
  imports: [CommonModule, TuiIcon, AvatarComponent, ChatHideMyselfPipe, UserNamePipe],
  templateUrl: './channel-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChannelAvatarComponent {
  @Input() channelType: ChannelType;
  @Input() channelUsers: ChannelUser[];
  @Input() size = Size.SMALL;

  ChannelType = ChannelType;
  Size = Size;
}
